import { render, staticRenderFns } from "./DiscountManagement.vue?vue&type=template&id=a8d7022e"
import script from "./DiscountManagement.vue?vue&type=script&lang=js"
export * from "./DiscountManagement.vue?vue&type=script&lang=js"
import style0 from "./DiscountManagement.vue?vue&type=style&index=0&id=a8d7022e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports